import { render, staticRenderFns } from "./packaging.vue?vue&type=template&id=22e10938&scoped=true"
import script from "./packaging.vue?vue&type=script&lang=js"
export * from "./packaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e10938",
  null
  
)

export default component.exports